<p><b> {{ lossAversionDescription.titleKey() | translate }} </b></p>

<p> {{ lossAversionDescription.quantileDescription() 
  | translate: {n: lossAversionDescription.percentageToPrint()} }} </p>

<p>{{ lossAversionDescription.details() | translate }}</p>

<p class="center"><b>Data to POST to the endpoint</b></p>
<pre>{{ preparePost() | json }}</pre>	
